export function receiveFixtureChangeResponse(context, { payload }) {
    const { rendererId, fixtureId } = payload;
    const { primaryRendererId } = context.getState();
    // Discard updates from secondary renderers
    if (rendererId !== primaryRendererId)
        return;
    const router = context.getMethodsOf('router');
    router.selectFixture(fixtureId);
}
